import { Directive, HostListener, Input } from "@angular/core";
import { WtfNavbarVerticalService } from "../../../services/navbar-vertical/navbar-vertical.service";
import { WtfNavbarVerticalComponent } from "../../../components/main/navbar/vertical/navbar-vertical.component";
import { WtfConfigService } from "../../../services/core/config.service";

@Directive({
    selector: "[wtfNavbarVertical]",
})
export class WtfNavbarVerticalToggleDirective {
    @Input() wtfNavbarVertical: string;
    navbar: WtfNavbarVerticalComponent;

    constructor(private navbarService: WtfNavbarVerticalService) {}

    @HostListener("click")
    onClick() {
        this.navbar = this.navbarService.getNavBar();

        if (!this.navbar[this.wtfNavbarVertical]) {
            return;
        }

        this.navbar[this.wtfNavbarVertical]();
    }
}
